import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { TooltipModule } from 'primeng/tooltip';
import { FormComponent, RowComponent } from '@src/app/components';

import { FormType } from './types';
import { createForm, createItem } from './utils';

@Component({
  selector: 'app-key-value-array',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormComponent,
    RowComponent,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    TooltipModule,
  ],
  templateUrl: './key-value-array.component.html',
  styleUrl: './key-value-array.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KeyValueArrayComponent implements OnInit {
  @Input() loading = false;
  @Input() form: FormGroup<FormType> = createForm();
  @Input() keySource: string[] = [];
  @Input() valueSource: string[] = [];

  get itemsControl() {
    return this.form.controls.items;
  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(value => {
      if (value.items) {
        const emptyItems = value.items.filter(item => !item.key && !item.value);
        if (emptyItems) {
          if (emptyItems.length === 0) {
            this.addItem();
          } else if (emptyItems.length > 1) {
            const emptyItemIndex = value.items.findIndex(item => !item.key && !item.value);
            if (emptyItemIndex > -1) {
              this.removeItem(emptyItemIndex);
            }
          }
        }
      }
    });
  }

  addItem() {
    this.itemsControl.push(createItem());
  }

  removeItem(index: number) {
    this.itemsControl.removeAt(index);
  }
}
